export const ALL_ASSETS_REQUEST = 'ALL_ASSETS_REQUEST';
export const ALL_ASSETS_SUCCESS = 'ALL_ASSETS_SUCCESS';
export const ALL_ASSETS_FAIL = 'ALL_ASSETS_FAIL';
export const CLEAR_ERRORS= 'CLEAR_ERRORS';